import { Component, OnInit } from '@angular/core';
// services
import { TranslateService } from '@ngx-translate/core';
import { ProfileCollectionFacadeV1 } from '@app/profile/components/profile-collection-v1/profile-collection.facade';
import { SubscriberBaseDirective } from '@app/shared/components/subscriber-base/subscriber-base.directive';

@Component({
  selector: 'dgx-profile-collection-search-v1',
  templateUrl: './profile-collection-search.component.html',
})
export class ProfileCollectionSearchV1
  extends SubscriberBaseDirective
  implements OnInit
{
  public searchTerm: string = '';

  public i18n = this.translateService.instant(['Core_Search']);

  constructor(
    private translateService: TranslateService,
    private profileCollectionFacade: ProfileCollectionFacadeV1
  ) {
    super();
  }

  public ngOnInit() {
    this.profileCollectionFacade.vm$
      .pipe(this.takeUntilDestroyed())
      .subscribe((vm) => {
        this.searchTerm = vm.filter.term;
      });
  }

  public onSearchSubmit(term: string): void {
    this.profileCollectionFacade.searchItems(term);
  }
}
